import { useEffect } from 'react';

import { isPersonObjectDataCurrent } from '../utils/MemberUtils';

import usePersonNationalTeamData from '../../../state/personNationalTeam/UsePersonNationalTeamData';

import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';

const useNationalTeamApparel = () => {
  const { basePersonState } = useBasePersonData();
  const { personNationalTeamState, getPersonNationalTeam, putPersonNationalTeam } = usePersonNationalTeamData();

  const onSubmitApparelForm = (personNationalTeamApparel) => {
    const personId = basePersonState.objData.personId;
    const newPersonNTObj = JSON.parse(JSON.stringify(personNationalTeamState.objData));
    newPersonNTObj.personNationalTeamApparel = personNationalTeamApparel;

    putPersonNationalTeam(personId, newPersonNTObj);
  };

  useEffect(() => {
    if (personNationalTeamState.isObjLoaded === false
      || !isPersonObjectDataCurrent(basePersonState.objData.personId, personNationalTeamState.objData)) {
      getPersonNationalTeam(basePersonState.objData.personId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePersonState]);

  return {
    isLoading: personNationalTeamState.isObjLoading,
    personId: basePersonState.objData.personId,
    competitionGenderTypeCode: basePersonState.objData.competitionGenderType?.typeCode,
    gridData: personNationalTeamState.objData?.personNationalTeamApparel || [],
    onSubmitApparelForm
  };
};

export default useNationalTeamApparel;